import { css } from 'styled-components'

export const linkStyles = css`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: inline-block;
  padding: 0;
  background-color: transparent;
  border: none;
  text-decoration: none;
  color: #333333;
  display: flex;
  white-space: nowrap;
  &:focus {
    outline: none;
  }
`

export const linkStylesHover = css`
  &:hover {
    color: #03b2a5;
    text-decoration: none;
  }
`

export const linkStylesHoverBg = css`
  &:hover {
    background-color: #f6f6f6;
  }
`
